package app.nestbridge.feature.invitations.ui

import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeScreen
import app.nestbridge.feature.invitations.screen.ShowInvitationQRCodeState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class ShowInvitationQRCodeUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is ShowInvitationQRCodeScreen -> ui<ShowInvitationQRCodeState> { state, modifier -> ShowInvitationQRCodeUi(state = state, modifier = modifier) }
    else -> null
  }
}
